import { googleLogout } from "@react-oauth/google";
import axios from "axios";
import configureStore from "../store";

const baseURL = process.env.REACT_APP_BASE_URL + "/api/v1";
const { store } = configureStore();

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  mode: "cors",
  "ngrok-skip-browser-warning": "true",
};

export const api = axios.create({ baseURL, headers, timeout: 1800000 });

// const formDataHeaders = {
//   'Content-Type': 'application/x-www-form-urlencoded',
// };

export function generateResourceMethod(resourceApi, method) {
  return function (path, data, config = {}) {
    return callApi(resourceApi, method, path, data, config);
  };
}

export const apiResource = {
  resourceAPI: api,
  get: generateResourceMethod(api, "get"),
  post: generateResourceMethod(api, "post"),
  put: generateResourceMethod(api, "put"),
  delete: generateResourceMethod(api, "delete"),
};

export const uploadImageApi = async (data) => {
  try {
    const response = await axios({
      method: "put",
      url: data.url,
      headers: {
        "Content-Type":
          data.file.type || data.mimeType || "application/octet-stream",
      },
      data: data.file,
    });
    return { success: true, response };
  } catch (e) {
    return { error: e };
  }
};

export const callApi = (resourceApi, method, path, data, config) => {
  const authToken = store.getState().tokenReducer.token;
  if (authToken) {
    api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
  }
  const apiCall = resourceApi[method](path, data, config);

  return apiCall.then(
    (responseWrapper) => {
      let { data } = responseWrapper;
      return data;
    },
    (err) => {
      if (err.response?.status === 403) {
        if (
          path.includes("milestones") ||
          path.includes("projects") ||
          path.includes("issues")
        ) {
          window.location.href = "/forbidden";
          return;
        }
        window.location.href = "/";
        localStorage.removeItem("persist:root");
        googleLogout();
      }

      return {
        data: err.response.data,
      };
    },
  );
};
